import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Band from "@/components/Band";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import MusicPage from "@/pages/MusicPage";
import SEO from "@/components/SEO";

function App() {
  // 'synthwave' or 'vintage'
  const [theme, setTheme] = useState("synthwave");

  useEffect(() => {
    const saved =
      typeof window !== "undefined" ? localStorage.getItem("oot-theme") : null;
    if (saved === "synthwave" || saved === "vintage") setTheme(saved);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("oot-theme", theme);
    }
  }, [theme]);

  const wrapperClass =
    theme === "synthwave" ? "theme-synthwave" : "theme-vintage grain";

  return (
    <BrowserRouter>
      <div className={wrapperClass} data-theme={theme} data-testid="app-root">
        <SEO />
        <Header theme={theme} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/band"
              element={
                <div className="pt-24">
                  <Band theme={theme} />
                </div>
              }
            />
            <Route path="/music" element={<MusicPage />} />
            <Route
              path="/book"
              element={
                <div className="pt-24">
                  <Booking theme={theme} />
                </div>
              }
            />
          </Routes>
        </main>
        <Footer theme={theme} />
      </div>
    </BrowserRouter>
  );
}

export default App;
